import React, { useState } from 'react'
import cn from 'classnames'
import { clamp, isUndefined } from 'lodash'
import { useField } from 'formik'

type NumberInputPropsType = React.InputHTMLAttributes<HTMLInputElement> & {
  containerClassName?: string
  name: string
}

export const NumberInput: React.FC<NumberInputPropsType> = ({
  className,
  containerClassName,
  ...props
}) => {
  const { value: initialValue, defaultValue } = props
  const [value, setValue] = useState(initialValue || defaultValue)
  const [, , /*field*/ /*meta*/ helpers] = useField(props)

  const updateValue = (changeValue: number) => {
    const nextValue = clamp(
      Number(value) + changeValue,
      isUndefined(props.min) ? -Infinity : Number(props.min),
      isUndefined(props.max) ? Infinity : Number(props.max)
    )
    setValue(nextValue)
    helpers.setValue(nextValue)
  }

  const changeHandler = React.useCallback(
    event => {
      const nextValue = Number(event.target.value)
      setValue(nextValue)
      helpers.setValue(nextValue)
    },
    [helpers]
  )

  return (
    <div className={cn('input-number', containerClassName)}>
      <input
        className={cn('input-number__input', className)}
        type="number"
        {...props}
        value={value}
        onChange={changeHandler}
      />
      <div
        className="input-number__add"
        onClick={updateValue.bind(null, Number(props.step) || 1)}
      />
      <div
        className="input-number__sub"
        onClick={updateValue.bind(null, -Number(props.step) || -1)}
      />
    </div>
  )
}
